import createAxiosInstance from '../createAxiosInstance'

const instance = createAxiosInstance(`${process.env.VUE_APP_CORE_URL}/api`)

const mapiPath = process.env.VUE_APP_MAPI_URL
const mapiInstance = createAxiosInstance(mapiPath)

export const apiPoint = {
  createNoteTemplate: ({ id, note }) => mapiInstance.post('/ServicePointNoteTemplate', { NoteTemplateTypeId: id, Note: note }),
  deleteNoteTemplate: (id) => mapiInstance.delete(`/ServicePointNoteTemplate/${id}`),
  getExcel: (year, month) => instance.get(`/Community/OrderingExcel/${year}/${month}`, {
    responseType: 'blob'
  }),
  getCommunityPrinters: () => instance.get('/Community/CommunityPrinters'),
  getNoteTemplates: (id) => mapiInstance.get(`/ServicePointNoteTemplate?TypeId=${id}`),
  updateNoteTemplate: ({ id, note }) => mapiInstance.put(`/ServicePointNoteTemplate/${id}`, { Note: note })
}
